module.exports = __webpack_public_path__ + "fonts/AmplitudeTF-BoldItalic_56892db8.5392eef9.eot";